import { Dispatch } from 'redux';
import { unbusyAll } from '../actions/commonActions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';
import { NOT_FOUND } from '@mm/constants/status-codes';
import modalActions from '../modules/modalsState/actions';
import { RetrieveByRemoteIdAction } from '../actions/ContactsCRUDActions';

export default (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, action?: string) => {
    if (
      error instanceof Response &&
      error.status === NOT_FOUND &&
      action === RetrieveByRemoteIdAction
    ) {
      dispatch(
        modalActions.openPrettyErrorModal({
          title: 'Not Found',
          errorMessage: 'Cannot find conversation',
        }),
      );
      dispatch(unbusyAll());
    } else {
      commonHandler(dispatch)(error);
    }
  };
